import React from 'react';
import ReactDOM from 'react-dom/client';
import Firebase, { FirebaseContext } from "./firebase"

// PrimeReact
import "primereact/resources/themes/bootstrap4-light-purple/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css";
// Primeflex
import "primeflex/primeflex.css";

// Custom CSS
import "./styles/global.css"
import "./styles/rewrites.css"

import App from "./App"

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <App />
  </FirebaseContext.Provider>,
);